import React from 'react';
import { Box } from '@mui/material';
import { CustomTextField } from 'shared/ui/CustomTextField';

interface NewParameterNameInputProps {
  newParameterName: string;
  setNewParameterName: (value: string) => void;
}

export const NewParameterNameInput: React.FC<NewParameterNameInputProps> = ({ newParameterName, setNewParameterName }) => (
  <Box component="div" sx={{ flex: 1 }}>
    <CustomTextField
      required
      label="new config name"
      variant="outlined"
      value={newParameterName}
      onChange={(e) => setNewParameterName(e.target.value)}
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-root': {
          backgroundColor: "#404040",
        },
      }}
    />
  </Box>
);
